import { RawSequenceItemsGetRequestParams } from "@lib/core";

export interface RawSequenceItemDefaultParams extends RawSequenceItemsGetRequestParams { }
export class RawSequenceItemDefaultParams {
  constructor() {
    this.select = "*";
    this.order = "id.asc";
  }
}